import { Checkbox } from '@/components/ui/checkbox';
import type { ThemeImportQuestion } from '@/api/theme-import-history.contract';
import type { translations } from '@/translations/translations';
import { ThemeQuestionDomain } from './ThemeQuestionDomain';

interface Props {
  copy: typeof translations.fr.admin.excelFiles.themes.questions;
  rows: ThemeImportQuestion[];
  themeSectorName: string;
  selectedIds: Set<string>;
  onToggle: (id: string) => void;
  onToggleVisible: () => void;
}

export function ThemeQuestionEditorList(props: Props) {
  const { copy, rows, selectedIds } = props;
  const isAllSelected = rows.length > 0 && rows.every((row) => selectedIds.has(row.id));
  return (
    <div className="overflow-hidden rounded-xl border border-border/50 bg-background">
      <div className="flex items-center gap-3 border-b border-border/50 bg-muted/30 px-4 py-3">
        <Checkbox checked={isAllSelected} onCheckedChange={props.onToggleVisible} aria-label={copy.selectAllVisible} />
        <span className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">{copy.selectAllVisible}</span>
      </div>
      <ul className="divide-y divide-border/40">
        {rows.map((row) => (
          <li key={row.id} className="grid grid-cols-[auto_minmax(0,1fr)] items-start gap-3 px-4 py-3 hover:bg-muted/20">
            <Checkbox checked={selectedIds.has(row.id)} onCheckedChange={() => props.onToggle(row.id)}
              aria-label={`${copy.selectQuestion}: ${row.questionText}`} className="mt-0.5" />
            <div className="min-w-0">
              <p className="break-words text-sm font-medium text-foreground">{row.questionText}</p>
              <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-[0.7rem] text-muted-foreground">
                <span className="inline-flex h-6 items-center rounded-md border border-border/40 bg-muted/50 px-2">{row.language ?? copy.unknownLanguage}</span>
                <span className="inline-flex h-6 max-w-full items-center rounded-md border border-border/40 bg-muted/50 px-2">
                  <ThemeQuestionDomain questionDomain={row.domain} themeSectorName={props.themeSectorName} copy={copy} />
                </span>
                <span className="inline-flex h-6 items-center rounded-md border border-border/40 px-2 font-mono text-[0.65rem] select-text" title={row.id}>{row.id}</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
